/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { bool } from 'prop-types';
import classNames from 'clsx';
import { TimelineMax, Power2 } from 'gsap';
import 'vendor/gsap/DrawSVGPlugin';

import KstingIcon from 'gfx/vector/ksting-icon.svg';

import styles from './spinner-icon.scss';

/**
 * This is the SpinnerIcon component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class SpinnerIcon extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {Object}
   */
  static propTypes = {
    small: bool,
    medium: bool,
    large: bool,
  };

  static defaultProps = {
    small: false,
    medium: false,
    large: false,
  };

  static tl = null;

  shouldComponentUpdate() {
    return false;
  }

  componentDidMount() {
    const circle = this.wrapper.querySelector('svg circle');
    const lines = this.wrapper.querySelectorAll('svg line');

    this.tl = new TimelineMax({
      repeat: -1,
      repeatDelay: 1,
    });

    this.tl
      .set([circle].concat(lines), {
        drawSVG: '0% 0%',
        visibility: 'hidden',
      })
      .fromTo(
        circle,
        2,
        {
          opacity: 0,
          drawSVG: '100% 100%',
        },
        {
          opacity: 1,
          drawSVG: '0% 100%',
          visibility: 'visible',
          ease: Power2.easeOut,
        }
      )
      .fromTo(
        lines[0],
        0.8,
        {
          drawSVG: '0% 0%',
        },
        {
          drawSVG: '100% 0%',
          visibility: 'visible',
          ease: Power2.easeOut,
        }
      )
      .fromTo(
        lines[1],
        0.4,
        {
          drawSVG: '0% 0%',
        },
        {
          drawSVG: '100% 0%',
          visibility: 'visible',
          ease: Power2.easeOut,
        }
      )
      .fromTo(
        lines[1],
        0.4,
        {
          drawSVG: '100% 0%',
        },
        {
          drawSVG: '100% 100%',
          ease: Power2.easeOut,
        }
      )
      .fromTo(
        lines[0],
        0.8,
        {
          drawSVG: '100% 0%',
        },
        {
          drawSVG: '100% 100%',
          ease: Power2.easeOut,
        }
      )
      .fromTo(
        circle,
        2,
        {
          drawSVG: '0% 100%',
        },
        {
          drawSVG: '0% 0%',
          ease: Power2.easeOut,
        }
      );
  }

  componentWillUnmount() {
    this.tl.kill();
  }

  /**
   * Render SpinnerIcon.
   *
   * @return {Object}
   */
  render() {
    const { small, medium, large } = this.props;

    const className = classNames({
      [styles.small]: small,
      [styles.medium]: medium,
      [styles.large]: large,
    });

    return (
      <div
        className={className}
        ref={ref => {
          this.wrapper = ref;
        }}
      >
        <KstingIcon />
      </div>
    );
  }
}
